import { intersection } from 'lodash';
import { FieldField, FieldCriterion } from 'store/organisations/types';
import { FieldResult } from 'types/types';
import { arrayHasSameMembers } from './arrayHasSameMembers/arrayHasSameMembers';

export const getFieldsHiddenByCriteria = ({
  fieldIds,
  fields,
  results,
}: {
  fieldIds: string[];
  fields: Record<string, FieldField>;
  results: Record<string, FieldResult>;
}): Record<string, boolean> =>
  Object.fromEntries(
    fieldIds.map((fieldId) => [
      fieldId,
      fields[fieldId]?.criteria.length
        ? fields[fieldId]!.criteria!.some(
            (criterion) =>
              !checkCriterion(criterion, results[criterion.fieldId]),
          )
        : false,
    ]),
  );

const checkCriterion = (
  criterion: FieldCriterion,
  result: undefined | FieldResult,
): boolean => {
  const fieldValue = result?.value;

  if (fieldValue === undefined) {
    if (criterion.allowBlank) {
      return true;
    }
    return false;
  }

  // Get value to test against
  const testValue: string | string[] = criterion.fieldValue || '';

  if (criterion.operator === 'includes' || criterion.operator === '!includes') {
    const outcome = !!intersection(
      Array.isArray(testValue) ? testValue : testValue ? [testValue] : [],
      Array.isArray(fieldValue) ? fieldValue : fieldValue ? [fieldValue] : [],
    ).length;
    return criterion.operator === 'includes' ? outcome : !outcome;
  }

  if (criterion.operator === '=' || criterion.operator === '!=') {
    if (Array.isArray(testValue)) {
      if (!Array.isArray(fieldValue)) {
        return false;
      }
      return criterion.operator === '='
        ? arrayHasSameMembers(testValue, fieldValue)
        : !arrayHasSameMembers(testValue, fieldValue);
    }
    if (Array.isArray(testValue)) {
      return false;
    }
    // eslint-disable-next-line eqeqeq
    return testValue == fieldValue;
  }

  return Array.isArray(testValue) !== Array.isArray(fieldValue)
    ? false
    : criterion.operator === '>'
      ? fieldValue > testValue
      : criterion.operator === '>='
        ? fieldValue >= testValue
        : criterion.operator === '<'
          ? fieldValue < testValue
          : fieldValue <= testValue;
  // : criterion.operator === '<='
  // ? fieldValue <= testValue
  // : false;
};
